module.exports = __webpack_public_path__ + "static/media/logo-nasa.15130ad0.svg";